import React from 'react';
import { FormattedMessage } from 'react-intl';
import InboxTransitionBase from './InboxTransitionBase';

const InboxTransitionOperatorCancel = ({ transition, buttons }) => {
  return (
    <InboxTransitionBase
      header={<FormattedMessage id="BookingStatus.transitionCancel" />}
      date={transition.createdAt}
      direction="left"
      buttons={buttons}
    >
      <FormattedMessage id="BookingStatus.transitionCancelSubtext" />
    </InboxTransitionBase>
  );
};

export default InboxTransitionOperatorCancel;
